export default {
  setCourierAccountInfo(store, accountInfo) {
    store.commit('setCourierAccountInfo', accountInfo);
  },
};
